import "./Loader.css";

const Loader = () => (
  <div className="lto-loader" role="status" aria-live="polite">
    <svg
      className="lto-loader__spinner"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle className="lto-loader__track" cx="24" cy="24" r="19" />
      <circle className="lto-loader__arc" cx="24" cy="24" r="19" />
    </svg>
    <span className="lto-loader__label">Loading…</span>
  </div>
);

export default Loader;
